<template>
  <CollapsibleLinks v-if="hasContentLinks">
    <template #trigger="{ toggle }">
      <a
        class="font-bold text-primary hover:text-primary-dark text-lg"
        @click.stop.prevent="toggle"
        >{{ $t("footer.content") }}</a
      >
    </template>
    <div class="flex flex-col mb-3 gap-1 text-sm">
      <FooterClickLink
        v-if="$branding.hasFeature(FEATURES.JOB_MARKET)"
        class="text-white"
        @click="requestTender({ source: 'footer' })"
      >
        {{ $t("footer.tender") }}
      </FooterClickLink>
      <NuxtLink
        v-if="$branding.hasFeature(FEATURES.PRICES)"
        :to="localePath({ name: 'pricesPage' })"
        class="text-white"
      >
        {{ $t("footer.pricing") }}
      </NuxtLink>
      <NuxtLink
        v-if="$branding.hasFeature(FEATURES.PROFESSIONALS)"
        :to="localePath({ name: 'professionsLandingPage' })"
        class="text-white"
      >
        {{ $t("footer.professions") }}
      </NuxtLink>
      <NuxtLink
        v-if="$branding.hasFeature(FEATURES.PROFESSIONALS)"
        :to="localePath({ name: 'citiesPage' })"
        class="text-white"
        >{{ $t("footer.cities") }}</NuxtLink
      >

      <FooterClickLink
        v-if="$branding.hasFeature(FEATURES.PROFESSIONALS)"
        class="text-white"
        :to="localePath({ name: 'newProfessionalsPage' })"
      >
        {{ $t("footer.newProfessionals") }}
      </FooterClickLink>
    </div>
  </CollapsibleLinks>
</template>

<script>
import { useContext, computed } from "@nuxtjs/composition-api";
import CollapsibleLinks from "./CollapsibleLinks.vue";
import FooterClickLink from "./FooterClickLink.vue";
import { useRequestTender } from "~/composables/requestTender";
import { FEATURES } from "~/config/pages/features.config";

export default {
  components: { CollapsibleLinks, FooterClickLink },
  setup() {
    const { requestTender } = useRequestTender();

    const { $branding } = useContext();
    const hasContentLinks = computed(() => {
      return (
        $branding.hasFeature(FEATURES.JOB_MARKET) ||
        $branding.hasFeature(FEATURES.PRICES) ||
        $branding.hasFeature(FEATURES.PROFESSIONALS)
      );
    });
    return {
      requestTender,
      hasContentLinks,
      FEATURES,
    };
  },
};
</script>
